import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    border-radius: ${theme.borderRadius.large};
    border: 1px solid ${theme.colors.secondary.seaweed50};
    position: relative;
    overflow: hidden;
    container-type: inline-size;
  `,
  header: css`
    display: flex;
    background-color: ${theme.colors.secondary.seaweed50}1a;
    padding: ${theme.spacing(2)};
    gap: ${theme.spacing(1)};
    align-items: center;
  `,
  headerTitle: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(0.5)};
  `,
  layoutBody: css`
    padding: ${theme.spacing(2)};
    background-color: ${theme.colors.white};
  `,
  body: css`
    display: flex;
    justify-content: space-between;
    gap: ${theme.spacing(2)};
  `,
  content: css`
    display: grid;
    grid-template-areas:
      'subtitle'
      'description'
      'actions';
    grid-template-rows: auto auto auto;
    grid-template-columns: 1fr;
    gap: ${theme.spacing(2)};
    max-width: 512px;
  `,
  subtitle: css`
    grid-area: subtitle;
  `,
  description: css`
    grid-area: description;
  `,
  actions: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};

    @media (max-width: ${breakpoints.small.max}px) {
      flex-direction: column;
      align-items: stretch;
    }
  `,
  dismissButton: css`
    color: ${theme.colors.neutral50};
  `,
  illustration: css`
    position: absolute;
    scale: 1.06;
    width: 352px;
    height: auto;
    top: calc(50% + ${theme.spacing(1)});
    right: ${theme.spacing(2)};
    padding: ${theme.spacing(2.5)};
    transform: translateY(-50%);
    @container (max-width: ${breakpoints.medium.max}px) {
      display: none;
    }
  `,
};
